import { TOAST_MESSAGE } from 'App/store/constants';

export const toastMessage = (data: any) => ({
  type: TOAST_MESSAGE,
  payload: data,
});
